import { render, staticRenderFns } from "./HeroSlider.vue?vue&type=template&id=0b8e3cae&scoped=true"
import script from "./HeroSlider.vue?vue&type=script&lang=js"
export * from "./HeroSlider.vue?vue&type=script&lang=js"
import style0 from "./HeroSlider.vue?vue&type=style&index=0&id=0b8e3cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8e3cae",
  null
  
)

export default component.exports